module.exports = __webpack_public_path__ + "static/media/ET.2cc67120.png";